var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{class:_vm.$style.dialog,attrs:{"visible":_vm.dialogVisible,"top":_vm.$mq !== 'lg' ? '0' : '5vh'},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('section',{class:_vm.$style.root},[_c('BaseForm',{attrs:{"select":[
          {
            name: 'Python',
            value: 'RW2ekO',
          },
          {
            name: 'JavaScript',
            value: 'VbrPUEWE3i',
          },
          {
            name: 'QA Automation',
            value: '6OWrIMNCFu',
          },
          {
            name: 'Android',
            value: 'Ns3S4M',
          } ],"show-camp-city":true,"hash":_vm.hash,"bg-color":"#fff","title":"Отправить заявку","file-title":"Прикрепить резюме","name-prefix":" - Практикант","text-area-placeholder":"Или напишите текст здесь"},on:{"closePopup":_vm.closePopup}})],1)]),_vm._v(" "),_c('section',[_c('v-dialog')],1),_vm._v(" "),_c('section',{class:[_vm.$style.root]},[_c('div',{class:[_vm.$style.container, _vm.$style.formContainer]},[_c('div',{class:_vm.$style.row},[_c('div',{class:[_vm.$style.col, _vm.$style.sendFeedback]},[_c('button',{class:_vm.$style.submit,attrs:{"aria-label":"Отправить заявку"},on:{"click":function($event){_vm.dialogVisible = true;}}},[_vm._v("\n            Отправить заявку\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45788d56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CampForm.vue
// module id = null
// module chunks = 